<template>
  <b-row>
    <b-col sm="1" md="1">
      <label class="form-control-label">{{ $t('views.firm.list.filters.state') }}:</label>
      <b-form-group>
        <b-form-radio-group
          v-model="filters.state"
          :options="yesAndNoStateOptions"
          buttons
          button-variant="outline-primary"
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-form-group>
    </b-col>
    <b-col sm="1" md="1">
      <label class="form-control-label">{{ $t('global.assigned') }}:</label>
      <b-form-group>
        <b-form-radio-group
          v-model="filters['lastPoolTask.operation']"
          :options="assignedOptions"
          buttons
          button-variant="outline-primary"
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-form-group>
    </b-col>
    <b-col sm="2" md="2">
      <label class="form-control-label">{{ $t('views.excmtask.list.deadlineExceeded') }}:</label>
      <b-form-group>
        <b-form-radio-group
          v-model="filters.taskFilterByProgress"
          :options="noAndYesStateOptions"
          buttons
          button-variant="outline-primary"
          name="radios-btn-default"
        ></b-form-radio-group>
      </b-form-group>
    </b-col>
    <b-col sm="6" md="4">
      <b-form-group>
        <label for="status_filter">{{ $t('views.excmtask.list.table.state') }}</label>
        <model-select
          :placeholder="$t('views.excmtask.list.table.state')"
          id="status_filter"
          v-model="filters.started" :options="stateOptions"></model-select>
      </b-form-group>
    </b-col>
    <b-col sm="12" md="4">
      <b-form-group>
        <label for="task_type_filter">{{ $t('views.excmtask.list.filters.idTaskType') }}</label>
        <multi-select :placeholder="$t('views.excmtask.list.filters.idTaskType')" @select="onSelectCurrentTaskType" :options="taskTypeOptions" :selected-options="currentTaskType"></multi-select>
      </b-form-group>
    </b-col>
    <b-col lg="4">
      <b-form-group>
        <label>{{ $t('views.excmcase.form.ownerUserData') }}</label>
        <base-select-input
          v-model="filters.filterTaskByCreatedBy"
          :search-callback="ownerUserDataSearchCallback"
          :display-values="['fullName', 'firmname1']"
          :query-param="'userdata'"
          :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
        ></base-select-input>
      </b-form-group>
    </b-col>
    <b-col sm="12" md="4">
      <b-form-group>
        <label for="serviceman_filter">{{ $t('routes.ServicemenShow') }}</label>
        <model-select
          :placeholder="$t('routes.ServicemenShow')"
          id="serviceman_filter"
          v-model="filters['lastPoolTask.operationTransferUserData']" :options="userDataOptions"></model-select>
      </b-form-group>
    </b-col>
    <b-col sm="12" md="4">
      <b-form-group>
        <label for="firm_filtering">{{ $t('views.financialreport.list.contractor') }}</label>
        <base-select-input
          v-model="filters['idCase.contractorUserData']"
          :search-callback="contractorSearchCallback"
          :display-values="['fullName', 'firmname1']"
          :query-param="'userdata'"
          :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
        ></base-select-input>
      </b-form-group>
    </b-col>
    <b-col cols="6" md="4" sm="12">
      <div class="form-group">
        <label for="excmcase_search_id" class="form-control-label">{{ $t('views.excmcase.list.searchParams.id') }}:</label>
        <input type="text" id="excmcase_search_id" class="form-control" v-model.lazy="filters.caseNumber" v-debounce="delay" :placeholder="$t('views.excmcase.list.searchParams.idPlaceholder')">
      </div>
    </b-col>
    <b-col cols="6" md="4" sm="12">
      <div class="form-group">
        <label for="customfields_search_id" class="form-control-label">{{ $t('views.excmcase.list.searchParams.filterTaskByCustomField') }}:</label>
        <input type="text" id="customfields_search_id" class="form-control" v-model.lazy="filters.filterTaskByCustomField" v-debounce="delay" :placeholder="$t('views.excmcase.list.searchParams.filterTaskByCustomField')">
      </div>
    </b-col>
    <!--  OWNER-->
  </b-row>
</template>

<script>
import debounce from 'v-debounce'
import { ModelSelect, MultiSelect } from 'vue-search-select'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'

export default {
  name: 'TasksFiltering',

  components: {
    ModelSelect,
    MultiSelect,
    BaseSelectInput
  },

  data () {
    return {
      filtersRadioInput: 0,
      currentTaskType: [],
      assignedOptions: [
        {
          value: 0,
          text: this.$t('buttons.no')
        },
        {
          value: [1, 2],
          text: this.$t('buttons.yes')
        }
      ],
      yesAndNoStateOptions: [
        {
          value: 1,
          text: this.$t('buttons.no')
        },
        {
          value: 0,
          text: this.$t('buttons.yes')
        }
      ],
      noAndYesStateOptions: [
        {
          value: 0,
          text: this.$t('buttons.no')
        },
        {
          value: 1,
          text: this.$t('buttons.yes')
        }
      ],
      stateOptions: [
        {
          value: 1,
          text: this.$t('views.excmtask.list.filters.started')
        },
        {
          value: 0,
          text: this.$t('views.excmtask.list.filters.finish')
        },
        {
          value: null,
          text: this.$t('global.all')
        }
      ],
      taskTypeOptions: [],
      delay: 500,
      filters: {
        caseNumber: '',
        idTaskType: [],
        'lastPoolTask.operation': '',
        state: null,
        taskFilterByProgress: null,
        started: null,
        finished: null, // if started = 0 then finished = 1
        'lastPoolTask.operationTransferUserData': null,
        'idCase.contractorUserData': null,
        filterTaskByCustomField: '',
        filterTaskByCreatedBy: ''
      },
      firmOptions: [],
      userDataOptions: []
    }
  },

  directives: {
    debounce
  },

  watch: {
    'filters.started' (val) {
      if (val !== null) this.filters.finished = +!val
      else this.filters.finished = null
    },
    filters: {
      deep: true,
      handler (val) {
        this.$emit('searchParams', val)
      }
    }
  },

  created () {
    this.fetchTaskTypeOptions()
    this.fetchFirmOptions()
    this.fetchUserDataOptions()
  },

  methods: {
    async fetchTaskTypeOptions () {
      let params = { pagination: false, forFiltering: 1 }
      const response = await new ApiService('e_x_c_m_task_types', params).getResults()
      this.taskTypeOptions = response.items.map(type => {
        return {
          value: getId(type['@id']),
          text: type.title + (type.idCasesType ? ' (' + type.idCasesType.title + ')' : '')
        }
      })
    },
    async contractorSearchCallback (params = {}) {
      let baseParams = { pagination: false, isContractor: 1, idClientType: 7 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async fetchFirmOptions () {
      let params = { pagination: false, isContractor: 1 }
      const response = await new ApiService('user_datas/list', params).getResults()
      this.firmOptions = response.items.map(userData => {
        return {
          value: getId(userData['@id']),
          text: userData.firmname1 ? userData.firmname1 : userData.fullName
        }
      })
      this.firmOptions.push({ text: this.$t('global.all'), value: null })
    },
    async fetchUserDataOptions () {
      // 4 - superuser, 5 - serwisant, 14 - controlling, 15 - przedstawiciel handlowy, 16 - projektant zewnętrzny
      let params = { pagination: false, isContractor: 0, idClientType: [...this.$store.getters['configuration/customClientTypeIds'], 4, 5, 14, 15, 16] }
      const response = await new ApiService('user_datas/list', params).getResults()
      this.userDataOptions = response.items.map(userData => {
        return {
          value: getId(userData['@id']),
          text: userData.fullName
        }
      })
      this.userDataOptions.unshift({ text: this.$t('global.all'), value: null })
      this.userDataOptions.unshift({ text: this.$t('notAssigned'), value: false })
    },
    async ownerUserDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isContractor: 0, idClientType: [...this.$store.getters['configuration/customClientTypeIds'], 4, 5, 8, 13, 14, 15, 16] }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    onSelectCurrentTaskType (items) {
      this.currentTaskType = items
      this.filters.idTaskType = items.map(option => getId(option.value))
    }
  }
}
</script>
